import Stardog from 'stardog';

export const isBody = (x: any): x is Stardog.HTTP.Body =>
  Object.keys(x).some((key) => key === 'ok');
